if ($('meta[name=enable_ga]').attr('content') == "1") {
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'G-PDRDSFKDBR');
}
